/**
 * Spieltag-Fortschritt nach dem eigenen Ergebnis:
 * zeigt fertige / noch offene Partien und pollt bis Mitternacht oder komplett.
 */
export default function MatchdayProgress({ board, polling = false }) {
  if (!board?.matches?.length) return null;

  const finished = Number(board.finished) || 0;
  const total = Number(board.total) || board.matches.length;
  const pending = Number(board.pending) || Math.max(0, total - finished);
  const pct = total ? Math.round((finished / total) * 100) : 0;
  const complete = Boolean(board.complete);

  return (
    <section className="rounded-2xl border border-sky-300/70 bg-sky-50 dark:bg-sky-950/30 dark:border-sky-700 p-4 shadow">
      <div className="flex flex-wrap items-end justify-between gap-2 mb-2">
        <div>
          <div className="text-xs uppercase tracking-wide opacity-70">Spieltag-Fortschritt</div>
          <h3 className="text-xl font-black">
            Spieltag {board.matchday}
            {complete ? " · komplett" : ` · noch ${pending}`}
          </h3>
        </div>
        <div className="text-sm font-semibold opacity-80">
          {finished}/{total} fertig
          {polling && !complete ? (
            <span className="ml-2 text-sky-700 dark:text-sky-300 animate-pulse">aktualisiert …</span>
          ) : null}
        </div>
      </div>

      <div className="h-2 rounded-full bg-sky-200/80 dark:bg-sky-900 overflow-hidden mb-3">
        <div
          className="h-full rounded-full bg-sky-600 transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>

      <p className="text-sm opacity-80 mb-3">
        {complete
          ? "Alle Partien des Spieltags sind durch — die Tabelle ist aktuell."
          : "Nur zur Info: die anderen (KI-)Spiele dieses Tags laufen parallel ein. Deinen nächsten Spieltag kannst du sofort spielen — darauf musst du nicht warten."}
      </p>

      <ul className="space-y-1.5">
        {board.matches.map((m) => {
          const done = m.status === "finished";
          return (
            <li
              key={m.id}
              className={`flex flex-wrap items-center justify-between gap-2 rounded-xl px-3 py-2 text-sm ${
                m.isYours
                  ? "bg-amber-100/90 dark:bg-amber-900/40 border border-amber-300/60"
                  : done
                    ? "bg-white/80 dark:bg-gray-800/60 border border-transparent"
                    : "bg-white/50 dark:bg-gray-800/40 border border-dashed border-sky-300/50"
              }`}
            >
              <div className="min-w-0">
                <span className="font-semibold">
                  {m.homeName} – {m.awayName}
                </span>
                {m.isYours ? (
                  <span className="ml-2 text-xs font-bold uppercase tracking-wide opacity-70">dein Spiel</span>
                ) : null}
              </div>
              <div className="font-black tabular-nums shrink-0">
                {done ? (
                  `${m.scoreHome}:${m.scoreAway}`
                ) : (
                  <span className="text-xs font-semibold opacity-60 animate-pulse">kommt noch …</span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
